export default "__VITE_ASSET__BbX8QdRY__"